import React, { useRef, useState, useEffect, useCallback } from 'react';
import Keyboard from 'react-simple-keyboard';

import { useTranslation } from 'react-i18next';
import { showNotification } from '@mantine/notifications';

import 'react-simple-keyboard/build/css/index.css';
import {
  Box,
  Center,
  Stack,
  Title,
  ActionIcon,
  Modal,
  Text,
  Group,
  Input,
  Image,
  Container,
} from '@mantine/core';
import { IconX } from '@tabler/icons';

import { Check } from 'tabler-icons-react';

import AlertImg from '../../image/alert.svg';

import PrimaryButton from '../../components/GroupButton';

import { sendRequest, sendRequestWithToken } from '../../services/services';

import TicketSummary from '../../components/TicketSummary/TicketSummary';

const UserDetails = () => {
  const { t } = useTranslation();

  const [, setMounted] = useState(false);
  const [, setLocation] = useState('');

  const [cardPay, setCardPay] = useState(false);
  const [errorPos, setErrorPos] = useState(false);
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));

  useEffect(() => {
    setMounted(true);
    setLocation(`${window.location.protocol}//${window.location.host}/`);
  }, []);

  const [ticketData, setTicketData] = useState();
  const [input, setInput] = useState('');
  const [layout, setLayout] = useState('default');
  const keyboard = useRef();
  const [buttonText, setButtonText] = useState('Arabic');

  // console.log('id', ticketData?.result?.passId);
  const searchTicket = useCallback(() => {
    sendRequest(`parking/site-id-by-pass-id/${input}`, 'get').then((data) => {
      if (data?.data?.site_id === siteDetails?.siteId) {
        sendRequest(`parking/reservations-by-pass-id/${input}`, 'get').then((res) => {
          if (res?.code === 20) {
            setTicketData(res?.data || []);
          } else if (res?.code === 21) {
            showNotification({
              title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
              icon: <IconX size={16} />,
            });
          }
        });
      } else if (data?.data?.site_id !== siteDetails?.siteId) {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.site.id')}</Text>,
          icon: <IconX size={16} />,
        });
      }
    });
  });

  const onChange = (inputValue) => {
    setInput(inputValue);
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (buttonText === 'Arabic') {
      setButtonText('English');
    } else if (buttonText === 'English') {
      setButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{enter}') searchTicket();
  };

  const onChangeInput = (event) => {
    const data = event.target.value;
    setInput(data);
    keyboard.current.setInput(data);
  };

  useEffect((button) => {
    if (button === '{enter}') {
      searchTicket();
    }
  }, []);

  const [response] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [, setCashData] = useState();

  useEffect(() => {
    if (response?.TerminalAction === 'SWIPE_OR_INSERT') {
      setCardPay(true);
    } else if (response?.TerminalAction === 'IDLE_SCREEN') {
      setCardPay(false);
    } else if (response?.EventName === 'TERMINAL_RESPONSE') {
      setPaymentStatus(JSON.parse(response?.JsonResult));
    }
  }, [response, ticketData?.result?.invoices?.invoice_status?.name]);

  useEffect(() => {
    if (response?.EventName === 'TERMINAL_RESPONSE') {
      const body = {
        reservation_id: parseInt(ticketData?.result?.id, 10),
        transaction_id: paymentStatus?.RetrievalReferenceNumber,
      };
      sendRequestWithToken(`cashier/card-payment`, 'post', body)
        .then(({ data, code }) => {
          if (code === 20) {
            setCashData(data);
            searchTicket();
            setCardPay(true);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            // console.log('err', err?.response?.data?.code);
          }
        });
    }
  }, [
    paymentStatus,
    paymentStatus?.RetrievalReferenceNumber,
    response?.EventName,
    searchTicket,
    ticketData?.result?.id,
  ]);

  return (
    <>
      <Modal opened={cardPay} onClose={() => setCardPay(false)} centered size="90%" />
      <Modal opened={errorPos} onClose={() => setErrorPos(false)} centered size="50%">
        <Center>
          <Image src={AlertImg} width={100} />;
        </Center>
        <Center py="xl">
          <Title order={1}>Error with Connection</Title>
        </Center>
      </Modal>

      <Box style={{ height: 'calc(100vh - 24px)', marginTop: '24px' }} className="no-printme">
        <Stack justify="space-between" style={{ height: '100%' }}>
          <Box>
            <Container
              className="home"
              style={{
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
              }}
            >
              <PrimaryButton />
            </Container>
          </Box>
          {!ticketData?.result?.id ? (
            <>
              <Box>
                <Container
                  className="home"
                  style={{
                    display: 'flex',
                    alignItems: 'stretch',
                    flexDirection: 'column',
                  }}
                >
                  <Stack>
                    <Title style={{ color: '#2C5864', margin: '2% 0' }} order={3}>
                      {t('enter.ticket.number')}
                    </Title>
                  </Stack>
                  <Stack style={{ color: '#2C5864', marginBottom: '0%' }}>
                    <Group style={{ direction: 'ltr', width: '100%' }}>
                      <Group style={{ direction: 'ltr', width: '100%' }}>
                        <Input
                          className="number-input"
                          style={{ width: 'calc(100% - 70px)' }}
                          placeholder={t('enter.ticket.number.placeholder')}
                          value={input}
                          onChange={onChangeInput}
                          size="xl"
                          disabled={ticketData?.result?.id}
                        />

                        <ActionIcon
                          onClick={() => searchTicket()}
                          color="teal"
                          size="xl"
                          radius="md"
                          variant="filled"
                          style={{ backgroundColor: '#50A847', width: '50px', height: '50px' }}
                        >
                          <Check size={44} />
                        </ActionIcon>
                      </Group>
                    </Group>
                  </Stack>
                </Container>
              </Box>
              <Box py="sm" style={{ direction: 'ltr', backgroundColor: '#22444E' }}>
                <Container>
                  <Keyboard
                    keyboardRef={(r) => {
                      keyboard.current = r;
                    }}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    layoutName={layout}
                    maxLength={19}
                    theme="hg-theme-default hg-layout-default myTheme numbers-only"
                    layout={{
                      theme: 'hg-theme-default',
                      default: ['1 2 3', '4 5 6', '7 8 9', '0 {bksp}'],
                    }}
                    display={{
                      '{bksp}': '←',
                      '{space}': ' ',
                    }}
                  />
                </Container>
              </Box>
            </>
          ) : null}
          {ticketData?.result?.id ? (
            <Box style={{ flexGrow: '1' }}>
              <Container
                className="home"
                style={{
                  display: 'flex',
                  alignItems: 'stretch',
                  flexDirection: 'column',
                  height: '100%',
                }}
              >
                <TicketSummary passId={input} />
              </Container>
            </Box>
          ) : null}
        </Stack>
      </Box>
    </>
  );
};

export default UserDetails;
